jQuery( function ( $ ) {

	var Vested_SS = {
		/**
		 * The sticky sidebar.
		 */
		sidebar: null,

		/**
		 * Max width for the sticky sidebar.
		 */
		maxWidth: 1100,

		/**
		 * Elements for the sidebar script.
		 */
		el: {},

		/**
		 * The page height percentages that should be animated.
		 */
		per: [ 10, 30, 60 ],

		/**
		 * The page height.
		 */
		height: null,

		/**
		 * Indicates it is safe to animate the tab.
		 */
		animate: true,

		/**
		 * Init all the things.
		 */
		init: function() {
			Vested_SS.el = {
				switch: $( '.tab-sidebar .switch button' ),
				tabContent: $( '.tab-sidebar .tab' ),
				window: $( window )
			};

			Vested_SS.makeSticky();
			$( window ).resize( Vested_SS.resize );

			Vested_SS.el.switch.click( Vested_SS.toggleSidebar );
			Vested_SS.el.window.scroll( Vested_SS.scroll );

		},
		/**
		 * Gets the page height.
		 *
		 * @returns {number}
		 */
		getHeight: function() {
			var body   = document.body,
				html   = document.documentElement;

			if ( null === Vested_SS.height ) {
				Vested_SS.height = Math.max(
					body.scrollHeight,
					body.offsetHeight,
					html.clientHeight,
					html.scrollHeight,
					html.offsetHeight
				);
			}

			return Vested_SS.height;
		},

		/**
		 * Checks the window scroll position.
		 */
		scroll: function() {
			var per = Math.round( Vested_SS.el.window.scrollTop() / Vested_SS.getHeight() * 100 );

			if ( Vested_SS.el.tabContent.hasClass( 'show' ) ) {
				return;
			}

			if ( Vested_SS.animate && Vested_SS.per.indexOf( per ) > -1 ) {
				Vested_SS.animateToggle();
			}
		},

		/**
		 * Animates the toggle.
		 */
		animateToggle: function() {
			Vested_SS.animate = false;

			Vested_SS.el.switch.animate( {
				'padding-right': '30px'
				},
				'fast'
			);
			setTimeout( function() {
				Vested_SS.el.switch.animate( {
						'padding-right': '20px'
					},
					'fast',
					function() {
						Vested_SS.animate = true;
					}
				);
			}, 0 );
		},

		/**
		 * Toggles the sidebar.
		 */
		toggleSidebar: function() {
			Vested_SS.el.switch.toggle();
			Vested_SS.el.tabContent.toggleClass( 'show' );
		},

		/**
		 * Checks to see if the sidebar should be sticky or not.
		 */
		resize: function() {
			if ( null !== Vested_SS.sidebar && window.innerWidth < Vested_SS.maxWidth ) {
				Vested_SS.unStick();
				return;
			}

			if ( null === Vested_SS.sidebar ) {
				Vested_SS.makeSticky()
			}
		},

		/**
		 * Makes the sidebar sticky if window is at least 1100px wide.
		 */
		makeSticky: function () {
			if ( window.innerWidth < Vested_SS.maxWidth ) {
				return;
			}

			Vested_SS.sidebar = new StickySidebar( '#genesis-sidebar-primary', {
				containerSelector: '.content-sidebar-wrap',
				topSpacing: 60,
				bottomSpacing: 0
			} );
		},

		/**
		 * Unsticks the sidebar.
		 */
		unStick: function() {
			Vested_SS.sidebar.destroy();
			Vested_SS.sidebar = null;
		}
	};

	$( document ).ready( Vested_SS.init );

} );
